/**
 * Converts a 2-letter ISO 3166-1 alpha-2 country code to a flag emoji.
 * Uses Unicode regional indicator symbols: each letter is offset from 'A' (0x41)
 * to the regional indicator 'A' (0x1F1E6).
 *
 * @param code - 2-letter ISO country code (e.g. "AU", "US", "GB")
 * @returns Flag emoji string (e.g. "🇦🇺") or placeholder "🏳️" if invalid/empty
 */
export function countryCodeToFlag(code: string | undefined | null): string {
  if (!code || code.length !== 2) {
    return PLACEHOLDER_FLAG;
  }

  const upper = code.toUpperCase();

  // Validate both characters are A-Z
  if (!/^[A-Z]{2}$/.test(upper)) {
    return PLACEHOLDER_FLAG;
  }

  const REGIONAL_INDICATOR_OFFSET = 0x1f1e6 - 0x41; // 'A' = 0x41
  return String.fromCodePoint(
    upper.charCodeAt(0) + REGIONAL_INDICATOR_OFFSET,
    upper.charCodeAt(1) + REGIONAL_INDICATOR_OFFSET,
  );
}

/** Empty placeholder for loading state or private IPs, preserves alignment via fixed-width span */
export const PLACEHOLDER_FLAG = "";

/** Flag shown for public IPs that weren't found in the geo database */
export const NOT_FOUND_FLAG = "❓";
